import axios from 'axios';
// config
import { HOST_API_KEY } from '../config-global';
import errorHandling from './errorHandling';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API_KEY });

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((errorHandling(error)) || 'Algum erro ocorreu')
);

export default axiosInstance;
